import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "18",
  cy: "30",
  r: "12",
  stroke: "#F69100"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "38.5",
  cy: "38.5",
  r: "3.5",
  stroke: "#F69100"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#F69100",
  d: "M38.5 35v-6.5m-19.694-14H34.5a4 4 0 0 1 4 4v10m-8.5 0h8.5M19.5 6l-2 24.5"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }